export default "__VITE_ASSET__d7093900__"